module.exports = __webpack_public_path__ + "img/seccion1.3.0391b1cb.png";